<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">新增账户</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()"/>
    </div>
    <!-- 返回 结束 -->
    <!-- 新增油卡顶部 开始 -->
    <!-- @click="handleItemTap(index)" -->
    <div class="page_tab">
      <div class="page_tablist" v-for="(item,index) in tabs" @click="handleItemTap(index)" >
        <div :class="item.isActive ? 'page_tabname':'page_tabname1'">{{item.value}}</div>
      </div>
    </div>
    <!-- 新增油卡顶部 结束 -->
    <!-- 新增油卡banner 开始 -->
    <div class="page_top"></div>
    <!-- 新增油卡banner 结束 -->
    <!-- 转让表单  开始 -->
    <!-- 银行卡 开始 -->
    <div v-if="tabsindex==0" class="page_taocan zhanghuadd_taocan">
      <div class="page_inputfrom zhanghuadd_input1">
        <div class="zhanghuadd_checktitle">银行名称:</div>
        <div @click="showPopup()" v-if="bindName==''" class="zhanghuadd_checkbox">
          <div class="zhanghuadd_check">请选择银行名称</div>
          <img class="zhanghuadd_checkimg" src="/static/newicon/more.png" />
        </div>
        <div @click="showPopup()" v-else class="zhanghuadd_checkbox">{{bindName}}</div>
      </div>
      <div class="page_inputfrom zhanghuadd_input1">
        <div class="zhanghuadd_checktitle">开户地址:</div>
        <div @click="showAddress()" v-if="addressName==''" class="zhanghuadd_checkbox">
          <div class="zhanghuadd_check">请选择开户地址</div>
          <img class="zhanghuadd_checkimg" src="/static/newicon/more.png" />
        </div>
        <div @click="showAddress()" v-else class="zhanghuadd_checkbox">{{addressName}}</div>
      </div>
      <div class="page_inputfrom zhanghuadd_input1">
        <div class="zhanghuadd_checktitle">银行卡号:</div>
        <input class="page_checkinput" type="number" placeholder="请输入银行卡号" v-model="cardNum" />
      </div>
      <div class="page_inputfrom zhanghuadd_input">
        <div class="zhanghuadd_checktitle">确认卡号:</div>
        <input class="page_checkinput" type="number" placeholder="请输入确认卡号" v-model="cardNumConfirm" />
      </div>
      <div class="page_inputfrom zhanghuadd_input">
        <div class="zhanghuadd_checktitle">手机号码:</div>
        <input class="page_checkinput" type="number" placeholder="请输入手机号码" v-model="phoneNum" />
      </div>
      <div class="page_inputfrom zhanghuadd_input">
        <div class="zhanghuadd_checktitle">开户网点:</div>
        <input class="page_checkinput" type="text" placeholder="例：广州分行" v-model="wangname" />
      </div>
      <div class="page_inputfrom zhanghuadd_input">
        <div class="zhanghuadd_checktitle">开户姓名:</div>
        <input class="page_checkinput" placeholder="请输入姓名" v-model="name2" />
      </div>
    </div>
    <!-- 银行卡 结束 -->
    <!-- 支付宝 开始 -->
    <div v-if="tabsindex==1" class="page_taocan zhanghuadd_taocan11">
      <div class="page_inputfrom zhanghuadd_input1">
        <div class="zhanghuadd_checktitle">账户号码:</div>
        <input class="page_checkinput" type="text" placeholder="请输入手机号或邮箱" v-model="zhiNum" />
      </div>
      <div class="page_inputfrom zhanghuadd_input">
        <div class="zhanghuadd_checktitle">确认账号:</div>
        <input class="page_checkinput" type="text" placeholder="请输入确认帐号" v-model="zhiNumConfirm" />
      </div>
      <div class="page_inputfrom zhanghuadd_input">
        <div class="zhanghuadd_checktitle">手机号码:</div>
        <input class="page_checkinput" type="number" placeholder="请输入手机号码" v-model="phoneNum" />
      </div>
      <div class="page_inputfrom zhanghuadd_input">
        <div class="zhanghuadd_checktitle1">账户名:</div>
        <input class="page_checkinput" type="text" placeholder="请输入您的真实姓名" v-model="name" />
      </div>
    </div>
    <!-- 支付宝 结束 -->
    <!-- 转让表单  结束 -->
    <!-- 提交 开始 -->
    <div class="page_button zhanghuadd_button" @click="addCard()">
      <div class="page_zhifu">添加</div>
    </div>
    <!-- 提交 结束 -->
    <!-- 银行名称弹出层 开始 -->
    <!--    <van-picker v-if="isshowBind" show-toolbar style="position: absolute;bottom: 0; left: 0; width: 100%;" :columns="bankNameList"
      @cancel="onCancel" @confirm="onConfirm" /> -->
    <van-popup v-model="isshowBind" position="bottom" :style="{ height: '40%' }">
      <van-picker show-toolbar :columns="bankNameList" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
    <!-- 银行名称弹出层 结束 -->
    <!-- 地址弹出层 开始 -->
    <!--  <van-area v-if="isshowAddress" :area-list="areaList" :columns-num="2" title="标题" /> -->
    <!-- <v-distpicker type="mobile" hide-area @selected='selected' v-show="addInp" class="area1">
    </v-distpicker> -->
    <van-popup v-model="isshowAddress" position="bottom" :style="{ height: '40%' }">
      <van-area :area-list="areaList" @confirm="confirmFn" @cancel='cancelFn' :columns-num="2" />
    </van-popup>
    <!-- 地址弹出层 结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http'
  import axios from 'axios'
  import VDistpicker from 'v-distpicker'
  import areaList from '../../plugins/area.js'
  export default {
    data() {
      return {
        tabs: [{
          value: "银行卡",
          isActive: true
        }, {
          value: "支付宝",
          isActive: false
        }], //
        // tabs: [{
        //   value: "银行卡",
        //   isActive: true
        // }], //
        tabsindex: 0, //tabs的index默认为0
        cardNum: '', // 加银行账户号,默认为空
        cardNumConfirm: '', // 确认银行帐号,默认为空
        zhiNum: '', //// 加支付宝账户号,默认为空
        zhiNumConfirm: '', //确认支付宝帐号,默认为空
        name: '', // 持号人,默认为空
        name2: '', // 持卡人,默认为空
        wangname: '', //开户网点，默认为空
        phoneNum: "", //手机号码，默认为空
        showTopTips1: false, // 错误提示(账户号码格式错误),默认为false
        showTopTips2: false, // 错误提示(账户号码与确认帐号不一致),默认为false
        showTopTips3: false, // 错误提示(持号人格式错误),默认为false
        showTopTips4: false, // 错误提示(手机号码格式错误),默认为false
        showTopTips5: false, // 错误提示(开户网点),默认为false
        isSinopec: true, // 用户是否点击选中中石化,默认为false
        phoneNumber: "", // 服务热线、客服电话
        buttonClicked: false, // 防止重复点击,默认为false
        getYouCard: [], //调用添加账户后后台返回的数据，默认为空
        hang: '', //键盘输入时触发,改变开户网点
        checkList: [],
        haveRedeemCode: false,
        amount: "",
        bankNameList: ['国家开发银行', '中国工商银行', '中国农业银行', '中国银行', '中国建设银行', '中国邮政储蓄银行',
          '交通银行', '招商银行', '上海浦东发展银行', '兴业银行', '华夏银行', '广东发展银行', '中国民生银行',
          '中信银行', '中国光大银行', '恒丰银行', '浙商银行', '渤海银行', '平安银行', '上海农村商业银行',
          '玉溪市商业银行', '尧都农商行', '北京银行', '上海银行', '江苏银行', '杭州银行', '南京银行', '宁波银行', '徽商银行',
          '长沙银行', '成都银行', '重庆银行', '大连银行', '南昌银行', '福建海峡银行', '汉口银行', '温州银行', '青岛银行',
          '台州银行', '嘉兴银行', '常熟农村商业银行', '南海农村信用联社', '常州农村信用联社', '内蒙古银行', '绍兴银行',
          '顺德农商银行', '吴江农商银行', '齐商银行', '贵阳市商业银行', '遵义市商业银行', '湖州市商业银行', '龙江银行',
          '晋城银行JCBANK', '浙江泰隆商业银行', '广东省农村信用社联合社', '东莞农村商业银行', '浙江民泰商业银行', '广州银行',
          '辽阳市商业银行', '江苏省农村信用联合社', '廊坊银行', '浙江稠州商业银行', '德阳商业银行', '晋中市商业银行',
          '苏州银行', '桂林银行', '乌鲁木齐市商业银行', '成都农商银行', '张家港农村商业银行', '东莞银行', '莱商银行', '北京农村商业银行',
          '天津农商银行', '上饶银行', '富滇银行', '重庆农村商业银行', '鞍山银行', '宁夏银行', '河北银行', '华融湘江银行',
          '自贡市商业银行', '云南省农村信用社', '吉林银行', '东营市商业银行', '昆仑银行', '鄂尔多斯银行', '邢台银行',
          '晋商银行', '天津银行', '营口银行', '吉林农信', '山东农信', '西安银行', '河北省农村信用社', '宁夏黄河农村商业银行',
          '贵州省农村信用社', '阜新银行', '湖北银行黄石分行', '浙江省农村信用社联合社', '新乡银行', '湖北银行宜昌分行',
          '乐山市商业银行', '江苏太仓农村商业银行', '驻马店银行', '赣州银行', '无锡农村商业银行', '广西北部湾银行',
          '广州农商银行', '江苏江阴农村商业银行', '平顶山银行', '泰安市商业银行', '南充市商业银行', '重庆三峡银行',
          '中山小榄村镇银行', '邯郸银行', '库尔勒市商业银行', '锦州银行', '齐鲁银行', '青海银行', '阳泉银行',
          '盛京银行', '抚顺银行', '郑州银行', '深圳农村商业银行', '潍坊银行', '九江银行', '江西省农村信用', '河南省农村信用',
          '甘肃省农村信用', '四川省农村信用', '广西省农村信用', '陕西信合', '武汉农村商业银行', '宜宾市商业银行',
          '昆山农村商业银行', '石嘴山银行', '衡水银行', '信阳银行', '鄞州银行', '张家口市商业银行', '许昌银行', '济宁银行',
          '开封市商业银行', '威海市商业银行', '湖北银行', '承德银行', '丹东银行', '金华银行', '朝阳银行', '临商银行', '包商银行',
          '兰州银行', '周口银行', '德州银行', '三门峡银行', '安阳银行', '安徽省农村信用社', '湖北省农村信用社', '湖南省农村信用社', '广东南粤银行',
          '洛阳银行', '农信银清算中心', '城市商业银行资金清算中心'
        ],
        isshowBind: false,
        isshowAddress: false,
        bindName: "",
        addressName: "",
        addressProvince: '省',
        addressCity: '市',
        addInp: false,
        mask: false,
        areaList,
      }
    },
    created() {
      if (this.$route.query.tabsid) {
        this.tabsindex = this.$route.query.tabsid
        if (this.tabsindex == 0) {
          this.tabs[0].isActive = true
          this.tabs[1].isActive = false
        } else {
          this.tabs[1].isActive = true
          this.tabs[0].isActive = false
        }

      } else {
        this.tabsindex = 0
      }
      if (this.$route.query.amount) {
        this.amount = this.$route.query.amount
      }
      if (this.$route.query.checkList) {
        this.checkList = JSON.parse(this.$route.query.checkList)
      }
      if (this.$route.query.haveRedeemCode) {
        this.haveRedeemCode = this.$route.query.haveRedeemCode
      }
       console.log("that.tabsindex",this.tabsindex)
    },
    mounted() {

    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      //银行弹框
      showPopup() {
        this.isshowBind = true
      },
      //地址弹框
      showAddress() {
        this.isshowAddress = true
      },
      //银行确认
      onConfirm(event) {
        this.bindName = event
        this.isshowBind = false
      },
      //银行取消
      onCancel() {
        this.isshowBind = false
      },
      //地址确认
      confirmFn(event) {
        this.addressProvince = event[0].name; // 省
        this.addressCity = event[1].name; // 市
        this.addressName = this.addressProvince + '-' + this.addressCity
        this.isshowAddress = false;
      },
      //地址取消
      cancelFn() {
        this.isshowAddress = false;
      },
      //返回上一页
      toReturn() {
        this.$router.go(-1)
      },

      //tabs点击事件
      handleItemTap(index) {
        let that = this
        let tabs = [{
          value: "银行卡",
          isActive: true
        }, {
          value: "支付宝",
          isActive: false
        }]
        tabs.forEach((v, i) => i === index ? v.isActive = true : v.isActive = false)
        that.tabs = tabs
        that.tabsindex = index
      },

      // 键盘输入时触发,改变加银行账户号
      cardNumInput() {

      },

      // 键盘输入时触发,改变确认银行帐号
      cardNumConfirmInput() {


      },
      // 键盘输入时触发,改变加支付宝账户号
      zhiNumInput() {


      },

      // 键盘输入时触发,改变确认支付宝帐号
      zhiNumConfirmInput() {


      },
      //键盘输入时触发,改变开户网点
      hangInput() {

      },
      // 键盘输入时触发,改变持号人
      nameInput() {

      },

      // 键盘输入时触发,改变持卡人
      name2Input() {

      },
      //键盘输入时触发，改变手机号
      phoneNumInput() {

      },

      // 点击添加账户
      addCard() {
        // 防止重复点击
        this.buttonClickedFun(1000)
        let that = this

        if (that.tabsindex == 1) {
          //支付宝账号注册
          // let name = that.name.replace(
          //   /[^\u2E80-\u2EFF\u2F00-\u2FDF\u3000-\u303F\u31C0-\u31EF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FBF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF]+/g,
          //   '')
          // 卡号长度或格式错误时顶部显示错误提示2秒(待施工)
          if (String(that.zhiNum).length < 0) {
            this.$toast({
              message: '请填写您的注册账户号',
            });
            return
          }
          // 卡号与确认卡号不一致时顶部显示错误提示2秒(待施工)
          if (that.zhiNum != that.zhiNumConfirm) {
            this.$toast({
              message: '帐号与确认帐号不一致',
            });
            return
          }
          // 手机号码格式错误时顶部显示错误提示2秒
          if (!/^1[0-9]{10}$/.test(that.phoneNum)) {
            this.$toast({
              message: '手机号码格式错误',
            });
            return
          }
          // 姓名长度或格式错误时顶部显示错误提示2秒
          if (this.name == "") {
            this.$toast({
              message: '名长度或格式错误',
            });
            return
          }
          that.request("addAlipay", {
            name: "" + that.name,
            account: "" + that.zhiNum,
            mobile: "" + that.phoneNum
          })

        } else {
          //银行卡账号注册
          let name2 = that.name2.replace(
            /[^\u2E80-\u2EFF\u2F00-\u2FDF\u3000-\u303F\u31C0-\u31EF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FBF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF]+/g,
            '')
          // 卡号长度或格式错误时顶部显示错误提示2秒(待施工)

          // if(String(that.cardNum).length = 0) {
          //     swal({
          //     text: '请填写银行卡号'
          //     })
          //   return
          // }
          if (this.bindName == "") {
            this.$toast({
              message: '请选择银行'
            })
            return
          }
          if (this.addressName == "") {
            this.$toast({
              message: '请选择开户地址'
            })
            return
          }
          //if (String(that.cardNum).length < 19) {
          if (String(that.cardNum).length < 8) { //特殊的银行 对公等有个位数长度
            this.$toast({
              message: '请填写正确的银行卡号'
            })

            return
          }
          // 卡号与确认卡号不一致时顶部显示错误提示2秒(待施工)
          if (that.cardNum != that.cardNumConfirm) {
            this.$toast({
              message: '帐号与确认帐号不一致'
            })
            return
          }
          // 手机号码格式错误时顶部显示错误提示2秒
          if (!/^1[0-9]{10}$/.test(that.phoneNum)) {
            this.$toast({
              message: '手机号码格式错误'
            })
            return
          }
          // 开户网点不能为空
          if (!(that.wangname)) {
            this.$toast({
              message: '开户网点不能为空!'
            })
            return
          }
          // 姓名长度或格式错误时顶部显示错误提示2秒
          if (name2.length == 0) {
            this.$toast({
              message: '名长度或格式错误'
            })
            return
          }
          let requestData = {
            real_name: "" + that.name2,
            card_no: "" + that.cardNum,
            bank: "" + that.wangname,
            mobile: "" + that.phoneNum,
            bank_name: "" + that.bindName,
            province_city: "" + that.addressName
          }
          that.request('addBinkCard', requestData)
        }

      },

      //调接口封装
      request(type, requestData = {}) {
        let that = this
        switch (type) {
          //添加支付宝
          case 'addAlipay':
            httper.post('user/add-alipay', requestData, res => {
              if (res.code === 0) {
                this.$toast({
                  message: '添支付宝成功'
                })
                // that.$router.push({ path: '/taoyao' })
                that.$router.push({
                  path: '/cardWithdraw',
                  query: {
                    amount: this.amount,
                    checkList: JSON.stringify(this.checkList),
                    haveRedeemCode: this.haveRedeemCode
                  }
                });
              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
            //添加银行卡
          case 'addBinkCard':
            httper.post('user/add-bank-card', requestData, res => {
              if (res.code === 0) {
                this.$toast({
                  message: '添银行卡成功'
                })
                // that.$router.push({ path: '/taoyao' })
                // that.$router.go(-1);
                that.$router.push({
                  path: '/cardWithdraw',
                  query: {
                    amount: this.amount,
                    checkList: JSON.stringify(this.checkList),
                    haveRedeemCode: this.haveRedeemCode
                  }
                });
              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
        }
      },
      // footer-点击拨打客服电话
      toCall() {

      },
    }
  }
</script>

<style>
.van-picker__cancel, .van-picker__confirm{
  color: #FD8C00!important;
}
  .zhanghuadd_taocan {
    /* height: 420px;
    top: 88px; */
    height: 100%;
    top: -160px;
  }

  .zhanghuadd_taocan11 {
    height: 100%;
    top: -160px;
   /* height: 260px;
    top: 88px; */
  }

  ::-webkit-input-placeholder {
    text-align: start !important;
    color: rgba(187, 187, 187, 1) !important;
    font-size: 14px !important;
  }

  .zhanghuadd_input1 {
    margin: 20px 20px 40px 20px;
  }

  .zhanghuadd_input {
    margin: 40px 20px;
  }

  .zhanghuadd_checktitle {
    margin-right: 20px;
  }

  .zhanghuadd_checktitle1 {
    margin-right: 34px;
  }

  .zhanghuadd_button {
   /* margin-top: 310px; */
    margin-top: -120px;
    margin-bottom: 20px;
  }

  .zhanghuadd_button1 {
    /*  margin-top: 210px; */
    /* margin-top: 155px; */
  }

  .zhanghuadd_check {
    font-size: 14px;
    font-weight: 400;
    color: rgba(187, 187, 187, 1);
  }

  .zhanghuadd_checkimg {
    width: 8px;
    height: 15px;
  }

  .zhanghuadd_checkbox {
    width: 180px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .van-picker {
    box-shadow: 0px -4px 5px 2px rgba(187, 187, 187, 0.3);

  }

  .van-picker__toolbar {

    align-items: center !important;
  }

  .van-picker__cancel {
    color: #969799;
  }

  .van-picker__confirm {
    color: #576b95;
  }

  .area1 {
    width: 100%;
    max-height: 45%;
    position: fixed;
    left: 0;
    bottom: 0;
    overflow-y: scroll;
    box-shadow: 0px -4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .distpicker-address-wrapper .address-header ul {
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
  }

  li {
    list-style: none;
  }

  .address-header {
    background-color: #fff;
    position: sticky;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/cardWithdrawAdd.vue